import GetToken from './token'
import { properties } from '../shared/properties'

export default function fetchData(raw, url) {

    //    let baseUrl = 'http://86.104.33.119:8081/'
    let baseUrl = properties.baseUrl

    var token = window.localStorage.getItem('token');
    var minutes = '';
    if (window.localStorage.getItem('expiration') != null && window.localStorage.getItem('expiration') != 'undefined' && window.localStorage.getItem('expiration') != '') {
        var expireDate = window.localStorage.getItem('expiration').split('_')
        var today = new Date();
        var time = expireDate[1].split('-')
        var times = time[0] + ':' + time[1]
        var expire = new Date(expireDate[0] + ' ' + times);
        var diff = Math.abs(expire - today) / 1000
        minutes = Math.floor(diff / 60)
    }

    var myHeaders = new Headers();
    var requestOptions = ''
    if (minutes < 11) {
        GetToken()
            .then(response => response.json())
            .then(result => {
                window.sessionStorage.setItem("expiration", result.expirationDate)
                window.sessionStorage.setItem("token", result.token)
                token = result.token
            })
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");
        requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        }
        return (
            fetch(baseUrl + url, requestOptions)
        )

    } else {
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");
        requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        }

        return (
            fetch(baseUrl + url, requestOptions)
        )
    }
}